import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private router: Router, private auth: AuthService) {}

  canActivate(): boolean {
    return this.checkAuthorization();
  }

  canActivateChild(): boolean {
    return this.checkAuthorization();
  }

  canLoad(): boolean {
    return this.checkAuthorization();
  }

  private checkAuthorization(): boolean {
    if (!this.auth.getIsLoggedIn()) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    return true;
  }
}
